import React from 'react';
import { bool, object, string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { LISTING_STATE_DRAFT } from '../../util/types';

import css from './ListingPage.module.css';
import { getSubscriptionDetailsData } from '../../util/userHelpers';

const SectionLimitExceeded = props => {
  const { currentListing, isOwnListing, className } = props;

  const { metadata } = currentListing?.attributes?.profile || {};
  const { subscription } = metadata || {};

  const { limitExceeded } = getSubscriptionDetailsData(subscription);
  const isDraft = currentListing?.attributes?.state === LISTING_STATE_DRAFT;

  const renderingCondition = limitExceeded && isDraft && isOwnListing;

  if (!renderingCondition) return null;

  return (
    <div className={classNames(css.limitExceeded, className)}>
      <FormattedMessage id="ManageListingCard.exceededLimit" />
    </div>
  );
};

SectionLimitExceeded.propTypes = {
  currentListing: object.isRequired,
  isOwnListing: bool.isRequired,
  className: string,
};

export default SectionLimitExceeded;
